import {
  faBagsShopping,
  // faCoinFront,
  faHome,
  faKeySkeleton,
  faQuestionCircle,
  faScrollOld,
  faStore,
  faTreasureChest,
  faUserCog,
  // faUserPlus,
  faWallet
} from '@fortawesome/pro-duotone-svg-icons'

import {
  SETTINGS_URL,
  CASHBACK_URL,
  EXCHANGE_POINTS_URL,
  HOME_URL,
  // MEMBERSHIP_URL,
  QUESTS_URL,
  REWARD_BOXES_URL,
  SHOP_URL,
  STAKING_URL,
  TRANSACTIONS_URL
} from '../constants/navigation'

import customConfig from 'customConfig'
import { coeRedemptionUrl } from '../util/navigation.helpers'
import brandConfig from 'brandConfig'
import { maskWalletAddress } from '../util/wallet/wallet.helpers'
import { Label } from '../components/label'

const { exchangeIcon, cashbackIcon, transactionsIcon } = customConfig

export const buildNavData = ({
  symbol,
  t,
  isQuestsEnabled,
  cashbackEarnOption,
  onWalletClick,
  connectedWallet,
  onStakingClick,
  onRewardBoxesClick
}) => {
  const { features } = brandConfig
  return [
    createNavSection(t('navigation.welcome'), [
      buildHomeMenu(t),
      createNavItem(
        connectedWallet
          ? `${t('common.connected')}: ${maskWalletAddress(connectedWallet)} `
          : t('wallet.connect-wallet'),
        '',
        faWallet,
        false,
        onWalletClick
      )
    ]),
    createNavSection(t('navigation.earn', { symbol }), [
      // createNavItem(
      //   t('navigation.staking'),
      //   STAKING_URL,
      //   faCoinFront,
      //   false,
      //   !connectedWallet && onStakingClick
      // ),
      createNavItem(
        t('brand:wallet.qbx-founders-key'),
        STAKING_URL,
        faKeySkeleton,
        false,
        !connectedWallet && onStakingClick
      ),
      ...buildQuestsMenu({ isQuestsEnabled, t }),
      ...(features.rewardBoxes
        ? [
            createNavItem(
              t('reward-box.reward-boxes'),
              REWARD_BOXES_URL,
              faTreasureChest,
              false,
              !connectedWallet && onRewardBoxesClick,
              <Label color='default' variant='inverted'>
                {t('shop.soon')}
              </Label>,
              true
            )
          ]
        : []),
      ...buildCashbackMenu({ cashbackEarnOption, t })
    ]),
    createNavSection(t('navigation.spend', { symbol }), [
      buildShopMenu(t),
      buildExchangeMenu({ t, symbol }),
      ...(features.enableCOEStorefront
        ? [
            createNavItem(
              t('navigation.online-store'),
              coeRedemptionUrl(),
              faBagsShopping,
              true,
              null,
              <Label color='default' variant='inverted'>
                {t('shop.soon')}
              </Label>,
              true
            )
          ]
        : [])
    ]),
    createNavSection(t('user-account.my-account'), buildAccountMenu({ t }))
  ]
}

const createNavSection = (subheader, items) => ({ subheader, items })
const createNavItem = (
  title,
  path,
  icon,
  external = false,
  onClickNav = null,
  info,
  disabled
) => ({
  title,
  path,
  icon,
  external,
  onClickNav,
  info,
  disabled
})

export const buildHomeMenu = (t) =>
  createNavItem(t('navigation.home'), HOME_URL, faHome)

const buildQuestsMenu = ({ t, isQuestsEnabled }) =>
  isQuestsEnabled
    ? [createNavItem(t('quest.quests'), QUESTS_URL, faScrollOld)]
    : []

const buildCashbackMenu = ({ t, cashbackEarnOption }) =>
  cashbackEarnOption
    ? [createNavItem(t('navigation.cashback'), CASHBACK_URL, cashbackIcon)]
    : []

const buildShopMenu = (t) =>
  createNavItem(t('navigation.qiibee-shop'), SHOP_URL, faStore)

const buildExchangeMenu = ({ t, symbol }) =>
  createNavItem(
    t('navigation.exchange', { symbol }),
    EXCHANGE_POINTS_URL,
    exchangeIcon
  )

export const buildAccountMenu = ({ t }) => [
  createNavItem(
    t('navigation.transaction-history'),
    TRANSACTIONS_URL,
    transactionsIcon
  ),
  createNavItem(t('navigation.settings'), SETTINGS_URL, faUserCog),
  createNavItem(
    t('navigation.help-center'),
    brandConfig.helpCenterUrl,
    faQuestionCircle,
    true
  )
]

export const buildHomeQuickMenu = ({
  isQuestsEnabled,
  cashbackEarnOption,
  t,
  symbol
}) => [
  ...buildQuestsMenu({ t, isQuestsEnabled }),
  ...buildCashbackMenu({ t, cashbackEarnOption }),
  buildShopMenu(t),
  buildExchangeMenu({ t, symbol })
]
